function RegisterFormController($scope, $q, $timeout, dataService) {
    $scope.model = {
        email: null,
        confirmEmail: null,
        //password: null,
        //password2: null,
        firstName: null,
        lastName: null,
        companyName: null,
        title: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        province: null,
        zip: null,
        country: null,
        phone: null,
        fax: null,
        companySize: null,
        utilizePhyTesting: null,
        whereHearAbout: null,
        whereHearAboutSource: null
    };
    $scope.states = null;
    $scope.countries = null;

    var init = function () {
        var loadSupport = function () {
            return $q.all([
                dataService.getStates(),
                dataService.getCountries()
            ]);
        };

        loadSupport().then(function (results) {
            $scope.states = results[0];
            $scope.countries = results[1];
            $scope.model.country = dataService.findCountry('US');
            //mockModel();
        });
    };
    init();

    var resetVal = function () {
        $scope.saving = {
            active: false,
            success: false,
            error: false
        };
        $scope.val = {
            email: {req: false, badFormat: false, dup: false, doesNotMatch: false},
            //password: {req: false, len: false, mat:false},
            firstName: {req: false},
            lastName: {req: false},
            companyName: {req: false},
            address: {req: false},
            city: {req: false},
            state: {req: false},
            //province: {req: false},
            postalCode: {req: false, fmt: false},
            phone: {req: false, badFormat: false},
            fax: {badFormat: false},
            companySize: {req: false},
            assessmentsUsed: {req: false},
            hear: {req: false},
            captcha: {req:false}
        };
    };
    resetVal();
    if (sessionStorage.getItem('registerSuccess') === 'true') {
        $scope.saving.then = true;
    }

    var scrollToError = function () {
        $timeout(function () {
            var $elm = angular.element('.ui-has-error');
            if (!$elm || $elm.length <= 0) return;
            var o = $elm.offset();
            angular.element('html,body').animate({scrollTop: o.top - 90}, 'fast');
        }, 0);
    };

    $scope.submit = function (e) {
        e.preventDefault();
        resetVal();
        var isValid = true;

        if (!$scope.model.email) {
            $scope.val.email.req = true;
            isValid = false;
        }
        else {
            if (!dataService.validEmail($scope.model.email)) {
                $scope.val.email.badFormat = true;
                isValid = false;
            }
            else {
                if ($scope.model.email !== $scope.model.confirmEmail) {
                    $scope.val.email.doesNotMatch = true;
                    isValid = false;
                }
            }
        }
        if (!$scope.model.firstName) {
            $scope.val.firstName.req = true;
            isValid = false;
        }

        if (!$scope.model.lastName) {
            $scope.val.lastName.req = true;
            isValid = false;
        }

        if (!$scope.model.companyName) {
            $scope.val.companyName.req = true;
            isValid = false;
        }

        if (!$scope.model.address) {
            $scope.val.address.req = true;
            isValid = false;
        }

        if (!$scope.model.city) {
            $scope.val.city.req = true;
            isValid = false;
        }

        if ($scope.model.country.id === 'US') {
            if (!$scope.model.state) {
                $scope.val.state.req = true;
                isValid = false;
            }
            if (!$scope.model.zip) {
                $scope.val.postalCode.req = true;
                isValid = false;
            }
        }
        else {
            /*if (!$scope.model.province) {
             $scope.val.province.req = true;
             isValid = false;
             }*/
            /*
             *if (!$scope.model.zip) {
             $scope.val.postalCode.req = true;
             isValid = false;
             }*/
        }


        if (!$scope.model.phone) {
            $scope.val.phone.req = true;
            isValid = false;
        }
        else {
            if (!dataService.validPhone($scope.model.phone)) {
                $scope.val.phone.badFormat = true;
                isValid = false;
            }
        }

        if ($scope.model.fax) {
            if (!dataService.validPhone($scope.model.fax)) {
                $scope.val.fax.badFormat = true;
                isValid = false;
            }
        }
        if (!$scope.model.companySize) {
            $scope.val.companySize.req = true;
            isValid = false;
        }
        if (!$scope.model.utilizePhyTesting) {
            $scope.val.assessmentsUsed.req = true;
            isValid = false;
        }
        if (!$scope.model.whereHearAbout) {
            $scope.val.hear.req = true;
            isValid = false;
        }

        $scope.model.captcha = grecaptcha.getResponse();
        if (!$scope.model.captcha) {
            $scope.val.captcha.req = true;
            isValid = false;
        }

        if (!isValid) {
            scrollToError();
            return;
        }

        $scope.saving.active = true;

        dataService.register($scope.model)
            .then(function () {
                $scope.saving.success = true;
                $scope.saving.active = false;
                sessionStorage.setItem('registerSuccess', 'true');
                var elm = document.getElementById('intro');
                if (elm) elm.style.display = 'none';
            })
            .catch(function () {
                $scope.saving.error = true;
                $scope.saving.active = false;
            });
    };

    $scope.selectChange = function (id) {
        var $elm = angular.element(id);
        if ($elm.children('option:first-child').is(':selected')) $elm.addClass('placeholder');
        else $elm.removeClass('placeholder');
    };
}

function SSARegisterFormController($scope, $q, $timeout, dataService) {
    $scope.model = {
        email: null,
        confirmEmail: null,
        //password: null,
        //password2: null,
        firstName: null,
        lastName: null,
        companyName: null,
        title: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        province: null,
        zip: null,
        country: null,
        url: null,
        phone: null,
        fax: null,
        stores: null,
        ssaMember: null,
        ssaMemberNumber: null,
        whereHearAbout: null,
        whereHearAboutSource: null
    };

    $scope.$watch(function(){
        return $scope.model.ssaMember
    }, function(newVal){
        if(newVal !== 'yes'){
            $scope.model.ssaMemberNumber = null;
        }
    });

    $scope.states = null;
    $scope.countries = null;

    var init = function () {
        var loadSupport = function () {
            return $q.all([
                dataService.getStates(),
                dataService.getCountries()
            ]);
        };

        loadSupport().then(function (results) {
            $scope.states = results[0];

            $scope.countries = results[1];
            $scope.model.country = dataService.findCountry('US');
        });
    };
    init();

    var resetVal = function () {
        $scope.saving = {
            active: false,
            success: false,
            error: false
        };
        $scope.val = {
            email: {req: false, badFormat: false, dup: false, doesNotMatch: false},
            //password: {req: false, len: false, mat:false},
            firstName: {req: false},
            lastName: {req: false},
            companyName: {req: false},
            address: {req: false},
            city: {req: false},
            state: {req: false},
            province: {req: false},
            postalCode: {req: false, fmt: false},
            phone: {req: false, badFormat: false},
            fax: {badFormat: false},
            //url: {req: false, badFormat: false},
            url: {req: false},
            stores: {req: false, badFormat: false},
            ssaMember: {req: false},
            hear: {req: false},
            captcha: {req:false}
        };
    };

    resetVal();
    if (sessionStorage.getItem('registerSuccess') === 'true') {
        $scope.saving.then = true;
    }

    var scrollToError = function () {
        $timeout(function () {
            var $elm = angular.element('.has-error');
            if (!$elm || $elm.length <= 0) return;
            var o = $elm.offset();
            angular.element('html,body').animate({scrollTop: o.top - 90}, 'fast');
        }, 0);
    };

    $scope.submit = function (e) {
        e.preventDefault();
        resetVal();
        var isValid = true;

        if (!$scope.model.email) {
            $scope.val.email.req = true;
            isValid = false;
        }
        else {
            if (!dataService.validEmail($scope.model.email)) {
                $scope.val.email.badFormat = true;
                isValid = false;
            }
            else {
                if ($scope.model.email !== $scope.model.confirmEmail) {
                    $scope.val.email.doesNotMatch = true;
                    isValid = false;
                }
            }
        }

        if (!$scope.model.firstName) {
            $scope.val.firstName.req = true;
            isValid = false;
        }

        if (!$scope.model.lastName) {
            $scope.val.lastName.req = true;
            isValid = false;
        }

        if (!$scope.model.companyName) {
            $scope.val.companyName.req = true;
            isValid = false;
        }

        if (!$scope.model.stores) {
            $scope.val.stores.req = true;
            isValid = false;
        }
        else {
            if (!dataService.validNumber($scope.model.stores)) {
                $scope.val.stores.badFormat = true;
                isValid = false;
            }
        }

        if (!$scope.model.address) {
            $scope.val.address.req = true;
            isValid = false;
        }

        if (!$scope.model.city) {
            $scope.val.city.req = true;
            isValid = false;
        }
        if ($scope.model.country.id === 'US') {
            if (!$scope.model.state) {
                $scope.val.state.req = true;
                isValid = false;
            }
            if (!$scope.model.zip) {
                $scope.val.postalCode.req = true;
                isValid = false;
            }
        }

        if (!$scope.model.url) {
            $scope.val.url.req = true;
            isValid = false;
        }


        if (!$scope.model.phone) {
            $scope.val.phone.req = true;
            isValid = false;
        }
        else {
            if (!dataService.validPhone($scope.model.phone)) {
                $scope.val.phone.badFormat = true;
                isValid = false;
            }
        }

        if ($scope.model.fax) {
            if (!dataService.validPhone($scope.model.fax)) {
                $scope.val.fax.badFormat = true;
                isValid = false;
            }
        }
        if (!$scope.model.ssaMember) {
            $scope.val.ssaMember.req = true;
            isValid = false;
        }
        if (!$scope.model.whereHearAbout) {
            $scope.val.hear.req = true;
            isValid = false;
        }

        $scope.model.captcha = grecaptcha.getResponse();
        if (!$scope.model.captcha) {
            $scope.val.captcha.req = true;
            isValid = false;
        }

        if (!isValid) {
            scrollToError();
            return;
        }

        $scope.saving.active = true;

        // Register!
        dataService.ssaRegister($scope.model)
            .then(function () {
                $scope.saving.success = true;
                $scope.saving.active = false;
                sessionStorage.setItem('registerSuccess', 'true');
                var elm = document.getElementById('intro');
                if (elm) elm.style.display = 'none';
            })
            .catch(function () {
                $scope.saving.error = true;
                $scope.saving.active = false;
            });
    };


    $scope.selectChange = function (id) {
        var $elm = angular.element(id);
        if ($elm.children('option:first-child').is(':selected')) $elm.addClass('placeholder');
        else $elm.removeClass('placeholder');
    };
}

angular.module('app')
    .component('registerForm', {
        controller: ['$scope', '$q', '$timeout', 'dataService', RegisterFormController],
        templateUrl: '/assets/built/app/components/register/registerForm.html'
    })
    .component('ssaRegisterForm', {
        controller: ['$scope', '$q', '$timeout', 'dataService', SSARegisterFormController],
        templateUrl: '/assets/built/app/components/register/ssaRegisterForm.html'
    });
